module.exports = __webpack_public_path__ + "static/media/write-password.2a246f42.svg";